/* istanbul ignore next */
const routes = [
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/agreement'),
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('@/views/app'),
    children: [
      {
        path: '/app/clients',
        name: 'app/clients',
        component: () => import('@/views/app/clients'),
        children: [
          {
            path: '/app/clients/:id',
            name: 'app/clients/:id/index',
            component: () => import('@/views/app/clients/_id/index'),
            children: [
              {
                path: '/app/clients/:id/details',
                name: 'app/clients/:id/details',
                components: {
                  clientPanel: () => import('@/views/app/clients/_id/details'),
                },
                children: [
                  {
                    path: '/app/clients/:id/details/summary',
                    name: '/app/clients/:id/details/summary',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/summary'),
                    },
                  },
                  {
                    path: '/app/clients/:id/details/holdings',
                    name: 'app/clients/:id/details/holdings',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/holdings'),
                    },
                  },
                  {
                    path: '/app/clients/:id/details/activity',
                    name: 'app/clients/:id/details/activity',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/activity'),
                    },
                  },
                  {
                    path: '/app/clients/:id/details/fees',
                    name: 'app/clients/:id/details/fees',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/fees'),
                    },
                  },
                  {
                    path: '/app/clients/:id/details/dashboard',
                    name: '/app/clients/:id/details/dashboard',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/dashboard/index'),
                    },
                  },
                  {
                    path: '/app/clients/:id/details/dashboard/:accountId',
                    name: '/app/clients/:id/details/dashboard/:accountId',
                    components: {
                      detailsPanel: () => import('@/views/app/clients/_id/details/dashboard/account-dashboard/index'),
                    },
                  },
                ],
              },
              {
                path: '/app/clients/:id/documents',
                name: 'app/clients/:id/documents',
                components: {
                  clientPanel: () => import('@/views/app/clients/_id/documents'),
                },
                children: [
                  {
                    path: '/app/clients/:id/documents/statements',
                    name: 'app/clients/:id/documents/statements',
                    components: {
                      documentsPanel: () => import('@/views/app/clients/_id/documents/statements'),
                    },
                  },
                  {
                    path: '/app/clients/:id/documents/taxes',
                    name: 'app/clients/:id/documents/taxes',
                    components: {
                      documentsPanel: () => import('@/views/app/clients/_id/documents/taxes'),
                    },
                  },
                  {
                    path: '/app/clients/:id/documents/other',
                    name: 'app/clients/:id/documents/other',
                    components: {
                      documentsPanel: () => import('@/views/app/clients/_id/documents/other'),
                    },
                  },
                ],
              },
              {
                path: '/app/clients/:id/active-transfers',
                name: 'app/clients/:id/active-transfers',
                components: {
                  clientPanel: () => import('@/views/app/clients/_id/active-transfers'),
                },
              },
            ],
          },
        ],
      },
      {
        path: '/app/overview',
        name: 'app/overview',
        component: () => import('@/views/app/overview'),
      },
      {
        path: '/app/profile',
        name: 'app/profile',
        component: () => import('@/views/app/profile'),
      },
      {
        path: '/app/resources',
        name: 'app/resources',
        component: () => import('@/views/app/resources'),
      },
      {
        path: '/app/revenue',
        name: 'app/revenue',
        component: () => import('@/views/app/revenue'),
      },
      {
        path: '/app/signup-link',
        name: 'app/signup-link',
        component: () => import('@/views/app/signup-link'),
      },
      {
        path: '/app/advisor-attestation-notification',
        name: 'app/advisor-attestation-notification',
        component: () => import('@/views/app/advisor-attestation-notification'),
      },
      {
        path: '/app/advisor-attestation-page',
        name: 'app/advisor-attestation-page',
        component: () => import('@/views/app/advisor-attestation-page'),
      },
      {
        path: '/app/*',
        name: 'app/notfound',
        component: () => import('@/views/app/notfound'),
      },
    ],
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/error'),
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/logout'),
  },
  {
    path: '/postauth',
    name: 'postauth',
    component: () => import('@/views/postauth'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/privacy'),
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('@/views/signin'),
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/signup'),
  },
  {
    path: '/worksfor',
    name: 'worksfor',
    component: () => import('@/views/worksfor'),
  },
  {
    path: '*',
    name: 'notfound',
    redirect: '/signin',
  },
];

export default routes;
